import React, { useMemo } from 'react';
import { createPortal } from 'react-dom';
import { LoadingStepsList } from './LoadingStepsList';
import './RefreshLoadingModal.css';

const BOARD_REFRESH_STEPS = [
  'Carregar ordens e técnicos',
  'Atualizar colunas de técnicos',
  'Recarregar técnicos visíveis',
  'Atualizar contagens de ordens',
];

const TECH_REFRESH_STEPS = [
  'Carregar dados do técnico',
  'Atualizar contagens concluídas',
  'Atualizar contagens finalizadas',
];

function resolveStepLabels(total, message) {
  if (total === 4) return BOARD_REFRESH_STEPS;
  if (total === 3) return TECH_REFRESH_STEPS;
  if (total > 0) {
    return Array.from({ length: total }, (_, i) => `Etapa ${i + 1}`);
  }
  return message ? [message] : ['Iniciando atualização...'];
}

function getStepStatus(index, current, total, message) {
  if (total <= 0) {
    return /erro/i.test(message || '') ? 'error' : 'active';
  }
  if (/concluíd/i.test(message || '') && current >= total) {
    return 'done';
  }
  const activeIndex = Math.max(0, Math.min(current, total) - 1);
  if (current <= 0) {
    return index === 0 ? 'active' : 'pending';
  }
  if (index < activeIndex) return 'done';
  if (index === activeIndex) return 'active';
  return 'pending';
}

export default function RefreshLoadingModal({ isOpen, progress }) {
  const { current = 0, total = 0, message = '' } = progress || {};

  const steps = useMemo(() => {
    const labels = resolveStepLabels(total, message);
    return labels.map((label, index) => {
      const status = getStepStatus(index, current, total, message);
      const text =
        status === 'active' && message && total > 0
          ? message.replace(/\.\.\.$/, '').trim() || label
          : label;
      return {
        id: `refresh-${total}-${index}`,
        label: text,
        status,
      };
    });
  }, [current, total, message]);

  if (!isOpen) return null;

  return createPortal(
    <div className="refresh-loading-overlay" role="alertdialog" aria-busy="true" aria-label="Atualizando dados">
      <LoadingStepsList steps={steps} />
    </div>,
    document.body
  );
}
